import { addNumbersAndResolvePrecision } from './number-precision';
import clone from '@sky-uk-ott/core-video-sdk-js-external-rfdc';
export var PROXIMITY_TO_AD_BREAK_START_THRESHOLD = 2;
export var findCloseToAdBreakStartPosition = function(position) {
    var adBreaksStartPositions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], threshold = arguments.length > 2 ? arguments[2] : void 0;
    var adBreakNearCurrentPosition = adBreaksStartPositions.find(function(adBreakStartPosition) {
        var absoluteDistanceFromAdBreakStart = Math.abs(adBreakStartPosition - position);
        return absoluteDistanceFromAdBreakStart <= (threshold || PROXIMITY_TO_AD_BREAK_START_THRESHOLD);
    });
    if (!adBreakNearCurrentPosition) {
        return null;
    }
    return adBreakNearCurrentPosition;
};
export var cloneAdBreakArray = function(adBreaks) {
    return adBreaks.map(function(adBreak) {
        return cloneAdBreak(adBreak);
    });
};
export var cloneAdBreak = function(adBreak) {
    return clone({})(adBreak);
};
export var cloneAd = function(ad) {
    var clonedAd = clone({})(ad);
    return clonedAd;
};
export var getScheduledEventKeyForAd = function(adBreak, ad) {
    return "".concat(adBreak.id, "_").concat(ad.id);
};
/**
 * Check if two ad breaks refer to the same break.
 */ export var areAdBreaksSame = function(adBreak1, adBreak2) {
    return adBreak1.id === adBreak2.id;
};
/**
 * Helper method to recalculate ad break expected duration based on ad durations.
 * @param adBreak The ad break containing ad durations to aggregate.
 * @returns Calculated ad break duration with precision resolved.
 */ export var recalculateAdBreakDuration = function(adBreak) {
    return adBreak.ads.reduce(function(dur, ad) {
        return addNumbersAndResolvePrecision(dur, ad.expectedDuration);
    }, 0);
};
/**
 * Helper method to reduce the Position attribute of an AdBreak object to a clean number.
 * @param position position attribute of AdBreak object
 * @returns position sanitised to an umber
 */ export var sanitisePosition = function(position) {
    return typeof position !== 'string' ? position : 0;
};
export var roughlyEquals = function(a, b, tolerance) {
    return Math.abs(a - b) < tolerance;
};
export var isEmptyAdBreak = function(adBreak) {
    return adBreak.ads.length === 0;
};
export var getAdBreakForAd = function(ad, availableAdBreaks) {
    return availableAdBreaks.find(function(adBreak) {
        return adBreak.id === ad.adBreakId;
    });
};

//# sourceMappingURL=ad-break-utils.js.map